import { Label, Radio } from 'flowbite-react';
import React from 'react';

interface Step2MandatesProps {
  willSignMandates: boolean | null;
  onChange: (value: boolean) => void;
}

const Step2Mandates: React.FC<Step2MandatesProps> = ({ willSignMandates, onChange }) => (
  <div className="space-y-4">
    <h3 className="text-lg font-medium">Est-ce vous qui signerez les mandats avec les copropriétaires qui souhaitent vendre leur bien ?</h3>
    <div className="flex space-x-4">
      <div className="flex items-center gap-2">
        <Radio
          name="signMandates"
          checked={willSignMandates === true}
          onChange={() => onChange(true)}
          id="signMandates-yes"
        />
        <Label htmlFor="signMandates-yes">Oui</Label>
      </div>
      <div className="flex items-center gap-2">
        <Radio
          name="signMandates"
          checked={willSignMandates === false}
          onChange={() => onChange(false)}
          id="signMandates-no"
        />
        <Label htmlFor="signMandates-no">Non</Label>
      </div>
    </div>
  </div>
);

export default Step2Mandates;


